const state = {
  all: []
}

const mutations = {
  updateControladoresList (state, res) {
    state.all = res.data
  }
}

const actions = {
  listControladores(context) {
    window.axios.get('/api/v2/controladores').then((res) => {
      context.commit('updateControladoresList', res)
    })
  },
  updateControlador (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.controlador)
    return window.axios.put('/api/v2/controladores/' + id, dados).then((res) => {
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Controladores.js